import { useLocation, useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import React, { useEffect, useRef, useState } from "react";
import { classDetails, sendCommentClassroom, AcceptRejectClassroom, sendCommentNew, list_comment, getClassReviews } from "../../../api/apiHandler";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import { TOAST_ERROR, TOAST_SUCCESS, formatDuration, displayPrice } from "../../../utils/common.service";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { useFormik } from "formik";
import moment from "moment";
import FileModal from "../../../components/FileModal";
import DataTable from "react-data-table-component";
import customStyles from "../../../utils/dataTableStyles";
import formatLocationAddress from "../../../utils/formatLocationAddress";

export default function ClassDetail({ isLoader }) {

    const [data, setData] = useState([])
    const [commentsList, setCommentsList] = useState([]);
    const [reviewsList, setReviewsList] = useState([]);
    const navigate = useNavigate()
    const location = useLocation()
    const classId = (location.state && location.state.class_id) || new URLSearchParams(location.search).get('class_id');

    const GetClassDetails = () => {
        isLoader(true)
        classDetails({ id: classId, type: "class" }).then((response) => {
            console.log('response :', response);
            if (response.code == 1) {
                setData(response.data[0])
                isLoader(false)
            } else {
                setData([])
                isLoader(false)
            }
        })
    }

    const GetClassComments = async () => {
        try {
            isLoader(true);
            const response = await list_comment({ comment_id: classId, action_type: "1200" });
            console.log('response :', response);
            if (response.code == 1) {
                const dataWithRowCount = response.data.map((row, index) => ({ ...row, count: index + 1 }));
                setCommentsList(dataWithRowCount);
            } else if (response.code == 0) {
                TOAST_ERROR(response.message);
            }
        } catch (error) {
            console.log('error :', error);
            TOAST_ERROR(error);
        } finally {
            isLoader(false);
        }
    };

    const GetClassReviews = async () => {
        try {
            isLoader(true);
            const response = await getClassReviews({ class_id: classId, type: "class" });
            if (response.code == 1) {
                const dataWithRowCount = response.data.map((row, index) => ({ ...row, count: index + 1 }));
                setReviewsList(dataWithRowCount);
            } else {
                setReviewsList([]);
            }
        } catch (error) {
            console.log('error :', error);
        } finally {
            isLoader(false);
        }
    };


    const reviewColumns = [
        {
            name: 'No',
            selector: row => row.count,
            sortable: false,
            width: "60px"
        },
        {
            name: 'Parent Name',
            selector: row => row.full_name || '-',
            sortable: true,
            width: "160px"
        },
        {
            name: 'Rating',
            selector: row => row.rating,
            sortable: true,
            width: "100px",
        },
        {
            name: 'Public Review',
            selector: row => row.review || '-',
            sortable: true,
            wrap: true,
        },
        {
            name: 'Admin Review',
            selector: row => row.comments_student_scholars || '-',
            sortable: true,
            wrap: true,
        },
        {
            name: 'Date',
            selector: row => {
                const date = new Date(row.created_at);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
            },
            sortable: true,
            width: "100px"
        },
    ];

    const columns = [
        {
            name: 'No',
            selector: row => row.count,
            sortable: false,
            width: "70px"
        },
        {
            name: "Date",
            selector: row => {
                const date = new Date(row.created_at);
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const formattedMonth = month < 10 ? `0${month}` : month;
                const formattedDay = day < 10 ? `0${day}` : day;
                const year = date.getFullYear();
                return `${formattedDay}-${formattedMonth}-${year}`;
            },
            sortable: true,
        },
        {
            name: "Admin name",
            selector: row => row.admin_name,
            sortable: true,
        },
        {
            name: "Comment",
            selector: row => row.comment,
            sortable: true,
        },
    ]

    useEffect(() => {
        GetClassDetails();
        GetClassComments();
        GetClassReviews();
    }, [classId]);

    const handleBack = () => {
        navigate(-1);
    };

    const handleAccpet = () => {
        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to accept this class?",
            showCancelButton: true,
            confirmButtonText: "Accept",
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    var objAccept = {
                        common_id: classId,
                        email: data.email,
                        is_accepted: 1,
                        type: "class",
                        status: "Listed"
                    };
                    isLoader(true)
                    AcceptRejectClassroom(objAccept).then((response) => {
                        if (response.code == 1) {
                            isLoader(false)
                            TOAST_SUCCESS(response.message);
                            setData(prevData => ({ ...prevData, is_accepted: "1" }));
                        } else {
                            isLoader(false)
                            TOAST_ERROR(response.message);
                        }
                    });
                } catch (error) {
                    TOAST_ERROR("Error..!!");
                }
            }
        });
    }

    const handleReject = () => {
        if (commentForm.values.comment.trim()) {
            Swal.fire({
                icon: "warning",
                title: "Are you sure you want to reject this class?",
                showCancelButton: true,
                confirmButtonText: "Reject",
            }).then((result) => {
                if (result.isConfirmed) {
                    try {
                        var objReject = {
                            common_id: classId,
                            email: data.email,
                            is_accepted: 2,
                            type: "class",
                            status: "Unlisted",
                            comment: commentForm.values.comment
                        };
                        isLoader(true)
                        AcceptRejectClassroom(objReject).then((response) => {
                            if (response.code == 1) {
                                isLoader(false)
                                TOAST_SUCCESS(response.message);
                                setData(prevData => ({ ...prevData, is_accepted: "2" }));
                                commentForm.resetForm();
                                GetClassComments();
                            } else {
                                isLoader(false)
                                TOAST_ERROR(response.message);
                            }
                        });
                    } catch (error) {
                        TOAST_ERROR("Error..!!");
                    }
                }
            });
        } else {
            TOAST_ERROR("Please enter the comment");
        }
    }

    const handleResubmit = () => {

        if (commentForm.values.comment.trim()) {
            Swal.fire({
                icon: "warning",
                title: "Are you sure you want to request for resubmit this class?",
                showCancelButton: true,
                confirmButtonText: "Resubmit",
            }).then((result) => {
                if (result.isConfirmed) {
                    try {
                        var objReject = {
                            common_id: classId,
                            email: data.email,
                            is_accepted: 3,
                            type: "class",
                            status: "Request for Resubmit",
                            comment: commentForm.values.comment
                        };
                        isLoader(true)
                        AcceptRejectClassroom(objReject).then((response) => {
                            if (response.code == 1) {
                                isLoader(false)
                                TOAST_SUCCESS(response.message);
                                setData(prevData => ({ ...prevData, is_accepted: "3" }));
                                commentForm.resetForm();
                                GetClassComments();
                            } else {
                                isLoader(false)
                                TOAST_ERROR(response.message);
                            }
                        });
                    } catch (error) {
                        TOAST_ERROR("Error..!!");
                    }
                }
            });
        } else {
            TOAST_ERROR("Please enter the comment");
        }
    }

    const fileInputs = useRef([]);
    const resetFileInputs = () => {
        fileInputs.current.forEach((input) => {
            input.value = '';
        });
    };

    const commentSchema = Yup.object({
        comment: Yup.string()
    });

    const commentForm = useFormik({
        initialValues: {
            comment: '',
        },
        validationSchema: commentSchema,

        onSubmit: async (values) => {
            console.log('values :', values);

            // values.id = classId;
            // values.email = data.email;
            // values.type = "class";
            if (values.comment.trim() != "") {
                values.action_id = classId;
                values.action_type = '1200';
                values.title = data.title;
                values.name = data.full_name;
                values.email = data.email;
                isLoader(true)
                sendCommentNew(values).then((response) => {
                    if (response.code == 1) {
                        TOAST_SUCCESS(response.message);
                        commentForm.resetForm();
                        resetFileInputs();
                        GetClassDetails();
                        GetClassComments();
                        isLoader(false)
                    } else {
                        TOAST_ERROR(response.message);
                        isLoader(false)
                    }
                });
            }
        },
    });

    const displayError = (fieldName) =>
        commentForm.touched[fieldName] && commentForm.errors[fieldName];

    const [selectedFile, setSelectedFile] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const openModal = (url) => {
        setSelectedFile(url);
        setShowModal(true);
    };

    const closeModal = () => {
        setSelectedFile(null);
        setShowModal(false);
    };

    return <>
        <JqueryLoad />
        <Hdashboard />
        <header className="dashboard-toolbar d-lg-flex justify-content-between">
            <div className="align-items-center justify-content-between d-flex">
                <div className="d-flex align-items-center">
                    <a className="menu-toggle align-items-center d-lg-none d-flex">
                        <i className="fa fa-bars" />
                    </a>
                    <a href="index.php" className="d-lg-none d-block brand-logo">
                        <img src="./assets/images/logo.png" alt="logo" />
                    </a>
                </div>
            </div>
        </header>
        <section className="main_sec">
            <div className="mt-4 mx-5 mb-5">
                <div>
                    <span onClick={handleBack}>
                        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" ></path>
                        </svg>
                        <span className="ms-2">Back</span>
                    </span>
                </div>
                {(
                    <>
                        <p className="ms-3 fs-3 fw-500 text-center mb-4">Class Details</p>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col col-lg-8 mb-4 mb-lg-0">
                                <div className="card mb-3 p-3" style={{ borderRadius: ".5rem" }}>
                                    <div className="row g-0">
                                        <div className="col-md-12">
                                            <div className="card-body p-4">
                                                <p className="mb-2 fs-5 fw-600">Information</p>
                                                <hr className="mt-0 mb-4" />
                                                <div className="row pt-1">
                                                    <div className="col-4 mb-4">
                                                        <p className="fw-500">Class Title </p>
                                                        <p className="text-muted mt-1">{data.title}</p>
                                                    </div>
                                                    <div className="col-4 mb-4">
                                                        <p className="fw-500">Class Type</p>
                                                        <p className="text-muted mt-1">{data.type}</p>
                                                    </div>
                                                    {data.type === "In-Person" && (
                                                        <div className="col-4 mb-4">
                                                            <p className="fw-500">Class Location</p>
                                                            <p className="text-muted mt-1">{formatLocationAddress(data) || "-"}</p>
                                                        </div>
                                                    )}
                                                    <div className="col-4 mb-4">
                                                        <p className="fw-500">Class Length</p>
                                                        <p className="text-muted mt-1">{data.length == "offline course" ? "Offline" : data.length}</p>
                                                    </div>
                                                    <div className="col-4 mb-4">
                                                        <p className="fw-500">Class Meets</p>
                                                        <p className="text-muted mt-1">
                                                            {data.length == "Multi-Day" &&
                                                                <span className="fw-600 d-block">{data.number_of_week}wks, {data.session_per_week}/wk</span>
                                                            }

                                                            {data.length == "Ongoing Weekly" || data.length == "Ongoing Monthly" &&
                                                                <span className="fw-600 d-block">{data.session_per_week}/wk</span>
                                                            }

                                                            {data.length == "Ongoing Weekly" &&
                                                                <span className="fw-600 d-block">{data.session_per_week}/wk</span>
                                                            }

                                                            {data.length == "One-Time" &&
                                                                <span className="fw-600 d-block">One-Time</span>
                                                            }
                                                            {data.length == "offline course" &&
                                                                <span className="fw-600 d-block">Offline Course</span>
                                                            }
                                                        </p>
                                                    </div>
                                                    {data.length != "offline course" &&
                                                        <div className="col-4 mb-4">
                                                            <p className="fw-500">Meeting Duration</p>
                                                            <p className="text-muted mt-1">{formatDuration(data?.duration)}</p>
                                                        </div>
                                                    }
                                                    <div className="col-4 mb-4">
                                                        <p className="fw-500">Class Video</p>
                                                        {/* {data.video_file && (
                                                            <a href={data.video_file} className="text-purple underline mt-1"> View Video</a>
                                                        )} */}
                                                        {data.video_file && (
                                                            <a onClick={() => openModal(data.video_file)} className="text-purple underline mt-1"> View Video</a>
                                                        )}
                                                    </div>
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500">Class Summary</p>
                                                        <p className="text-muted mt-1" dangerouslySetInnerHTML={{ __html: data.summary }} />
                                                    </div>

                                                    <div className="col-4 mb-4">
                                                        <p className="fw-500">Main Category</p>
                                                        <p className="text-muted mt-1">{data.main_category}</p>
                                                    </div>
                                                    {/* <div className="col-4 mb-4">
                                                        <p className="fw-500">Sub Category</p>
                                                        <p className="text-muted mt-1">{data.subject_category}</p>
                                                    </div> */}
                                                    {data?.subcategories?.length > 0 && (
                                                        data?.subcategories?.map((item) => {
                                                            return (
                                                                <div className="col-4 mb-4">
                                                                    <p className="fw-500">{item?.subcategory}</p>
                                                                    <p className="text-muted mt-1">{item?.subject}</p>
                                                                </div>
                                                            )
                                                        })
                                                    )}
                                                    {data.min_age === 0 && data.max_age === 0 ?
                                                        <div className="col-4 mb-4">
                                                            <p className="fw-500">Learner Age</p>
                                                            <p className="text-muted mt-1">Adults</p>
                                                        </div> : data.min_age === 0 ?
                                                            <>
                                                                <div className="col-4 mb-4">
                                                                    <p className="fw-500">Minimum Learner Age</p>
                                                                    <p className="text-muted mt-1">0</p>
                                                                </div>
                                                                <div className="col-4 mb-4">
                                                                    <p className="fw-500">Maximum Learner Age</p>
                                                                    <p className="text-muted mt-1">{data.max_age}</p>
                                                                </div>
                                                            </> : data.max_age === 0 ?
                                                                <>
                                                                    <div className="col-4 mb-4">
                                                                        <p className="fw-500">Minimum Learner Age</p>
                                                                        <p className="text-muted mt-1">{data.min_age}</p>
                                                                    </div>
                                                                    <div className="col-4 mb-4">
                                                                        <p className="fw-500">Maximum Learner Age</p>
                                                                        <p className="text-muted mt-1">Adults</p>
                                                                    </div>
                                                                </> :
                                                                <>
                                                                    <div className="col-4 mb-4">
                                                                        <p className="fw-500">Minimum Learner Age</p>
                                                                        <p className="text-muted mt-1">{data.min_age}</p>
                                                                    </div>
                                                                    <div className="col-4 mb-4">
                                                                        <p className="fw-500">Maximum Learner Age</p>
                                                                        <p className="text-muted mt-1">{data.max_age}</p>
                                                                    </div>
                                                                </>
                                                    }
                                                    {/* <div className="col-4 mb-4">
                                                        <p className="fw-500">Minimum Learner Age</p>
                                                        <p className="text-muted mt-1">{data.min_age}</p>
                                                    </div>
                                                    <div className="col-4 mb-4">
                                                        <p className="fw-500">Maximum Learner Age</p>
                                                        <p className="text-muted mt-1">{data.max_age}</p>
                                                    </div> */}
                                                    <div className="col-4 mb-4">
                                                        <p className="fw-500">Class Size</p>
                                                        <p className="text-muted mt-1 text-capitalize">{data.class_size == "private" || data.length == "offline course" ? "1-on-1 Private Class" : data.class_size}</p>
                                                    </div>
                                                    {data.class_size != "private" &&
                                                        <>
                                                            <div className="col-4 mb-4">
                                                                <p className="fw-500">Minimum Learner</p>
                                                                <p className="text-muted mt-1">{data.min_learner}</p>
                                                            </div>
                                                            <div className="col-4 mb-4">
                                                                <p className="fw-500">Maximum Learner</p>
                                                                <p className="text-muted mt-1">{data.max_learner}</p>
                                                            </div>
                                                        </>}

                                                    <div className="col-4 mb-4">
                                                        <p className="fw-500">Pre-requisites</p>
                                                        <p className="text-muted mt-1">{data?.pre_requisites_title}</p>
                                                    </div>
                                                    <div className="col-4 mb-4">
                                                        <p className="fw-500">Language of instruction</p>
                                                        <p className="text-muted mt-1">{data.class_language}</p>
                                                    </div>
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500">Description </p>
                                                        <p className="text-muted mt-1" dangerouslySetInnerHTML={{ __html: data.description }} />
                                                    </div>
                                                    {(data.homeworks != "" && data.homeworks != null) &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-500">Homework(Optional) </p>
                                                            <div className="text-muted mt-1" dangerouslySetInnerHTML={{ __html: data.homeworks }} />
                                                        </div>
                                                    }
                                                    {(data.assessment != "" && data.assessment != null) &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-500">Assessment(Optional) </p>
                                                            <div className="text-muted mt-1" dangerouslySetInnerHTML={{ __html: data.assessment }} />
                                                        </div>
                                                    }
                                                    {(data.parental_guide != "" && data.parental_guide != null) &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-500"> Parental Guidance (Optional) - For Learners Under 18 Years Old </p>
                                                            <div className="text-muted mt-1" dangerouslySetInnerHTML={{ __html: data.parental_guide }} />
                                                        </div>
                                                    }
                                                    {(data.source != "" && data.source != null) &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-500"> Sources (Required For Certain Topics – Optional)</p>
                                                            <div className="text-muted mt-1" dangerouslySetInnerHTML={{ __html: data.source }} />
                                                        </div>
                                                    }
                                                    {(data.supply_list != "" && data.supply_list != null) &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-500">Learner Supply List(Optional)</p>
                                                            <div className="text-muted mt-1" dangerouslySetInnerHTML={{ __html: data.supply_list }} />
                                                        </div>
                                                    }
                                                    {(data.next_class != "" && data.next_class != null) &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-500">Next Class(Optional)</p>
                                                            <p className="text-muted mt-1">{data?.next_class_title}</p>
                                                        </div>
                                                    }
                                                    <div className="col-3 mb-4">
                                                        <p className="fw-500">Class Price</p>
                                                        <p className="text-muted mt-1">{displayPrice(data?.price, data?.currency_code, data?.currency_symbol)}</p>
                                                    </div>
                                                    <div className="col-4 mb-4">
                                                        <p className="fw-500">Class Created Date</p>
                                                        <p className="text-muted mt-1"> {moment(data.created_at).format("DD MMMM YYYY")}</p>
                                                    </div>

                                                    {/* <div className="col-12 mb-4">
                                                        <p className="fw-500">Admin Comments</p>
                                                        <p className="text-muted mt-1">{data.comments}</p>
                                                    </div> */}
                                                </div>

                                                <form className="custom_form mt-4" name="commentForm" onSubmit={commentForm.handleSubmit}>

                                                    <div className="form-group mb-4">
                                                        <p className="fw-500 mb-2">Any comments you have, please add them here for this class.</p>
                                                        <textarea type="text" className="form-control" name="comment" value={commentForm.values.comment} rows="5" cols="33" onChange={commentForm.handleChange} ></textarea>
                                                        {displayError("comment") && (
                                                            <div className="text-danger">{commentForm.errors.comment}</div>
                                                        )}
                                                        {/* <div className="button mt-2 mb-2 d-flex justify-content-end">
                                                            <button type="submit" className="btn-theme px-4 py-2  text-center text-dif-black fw-500 bg-yellow mb-xl-0 mb-3 d-inline-block">Send</button>
                                                        </div> */}
                                                    </div>
                                                </form>

                                                <div className="d-flex justify-content-center mt-3">
                                                    <button className={`btn-theme ${data.is_accepted == "3" && "bg-info text-white"} mx-1`} onClick={() => handleResubmit()} disabled={data.is_accepted == "3" ? true : false}>
                                                        {data.is_accepted == "3" ? "Request for ReSubmitted" : data.is_accepted == "4" ? "Resubmitted " : "Resubmit"}
                                                    </button>
                                                    <button className={`btn-theme ${data.is_accepted == "1" ? "bg-success text-white" : "bg-yellow"} mx-1`} onClick={() => handleAccpet()} disabled={data.is_accepted == "1" ? true : false}>
                                                        {data.is_accepted == "1" ? "Accepted" : "Accept"}
                                                    </button>
                                                    <button className={`btn-theme ${data.is_accepted == "2" && "bg-danger text-white"} mx-1`} onClick={() => handleReject()} disabled={data.is_accepted == "2" ? true : false}>
                                                        {data.is_accepted == "2" ? "Rejected" : "Reject"}
                                                    </button>
                                                    <button className="btn-theme mx-1" onClick={() => navigate(-1)} >
                                                        Back
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {commentsList?.length > 0 && (
                                    <div className="card mb-3 p-3" style={{ borderRadius: ".5rem" }}>
                                        <div className="row g-0">
                                            <div className="col-md-12">
                                                <div className="card-body p-4">
                                                    <DataTable
                                                        persistTableHead
                                                        columns={columns}
                                                        data={commentsList}
                                                        pagination
                                                        customStyles={customStyles}
                                                        className="custom-data-table"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="card mb-3 p-3" style={{ borderRadius: ".5rem" }}>
                                    <div className="card-body p-4">
                                        <p className="mb-3 fs-5 fw-600">Parent Reviews</p>
                                        {reviewsList.length > 0 ? (
                                            <DataTable
                                                persistTableHead
                                                columns={reviewColumns}
                                                data={reviewsList}
                                                pagination
                                                customStyles={customStyles}
                                                className="custom-data-table"
                                            />
                                        ) : (
                                            <p className="text-muted text-center py-3">No reviews found for this class.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </section>

        {showModal && <FileModal isOpen={showModal} fileUrl={selectedFile} onClose={closeModal} />}
    </>
}

